import { IVideoDataMatchedQuestion } from "@/pages/VideoPage/interfaces";
import { getSubjectLink } from "@/utils";
import { getVernacularLanguage, isVernacular } from "@/utils/language";
import VideoDuration from "../Badge/VideoDuration";
import MathJax from "../MathJaxText";
import FaChevronRight from "../SVG/Fontawesome/FaChevronRight";
import LinkWrapper from "@/components/LinkWrapper";

const SimilarBlock = (props: {
  data: IVideoDataMatchedQuestion;
  similarMathJax: string;
  target?: string;
  view?: "CAROUSEL" | "CAROUSEL_STATIC" | "VERTICAL";
}) => {
  let href = `/qna/${props.data.question_id}`;
  const view = props.view ?? "VERTICAL";

  return (
    <li className={`flex justify-center mx-auto grow pl-0 ${view === "VERTICAL" ? "w-full" : "shrink-0 w-[80vw] sm:w-10/12 snap-center"}`}>
      <LinkWrapper href={href} target={props.target} className="similar-block no-underline card p-0 sm:hover-pop bg-secondary sm:min-w-[18rem] w-full rounded-2xl flex flex-col grow">
        <div className="grow relative w-full flex items-center justify-center flex-col rounded-t-md" >
          <p className="h-full min-h-[8rem] flex items-center justify-center w-full text-base px-4">
            <MathJax ocrText={props.similarMathJax} />
          </p>
        </div>
        <hr className="my-0" />
        {/* TODO: what about the duration tag? - removed from design */}
        {/* <span>
            <VideoDuration duration={props.data.duration}/>
          </span> */}
        <span className="bg-primary relative inset-0 self-stretch flex justify-center py-3 rounded-b-2xl text-white  gap-2 text-sm">
          <span>View Solution</span>
        </span>
      </LinkWrapper>
    </li>
  );
}

export default SimilarBlock